"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionMethods = void 0;
const config_1 = require("./config");
const permissions_1 = require("./permissions");
exports.collectionMethods = Object.assign(Object.assign({}, permissions_1.collectionPermissionMethods), config_1.collectionConfigMethods);
//# sourceMappingURL=index.js.map